<div class="cb-featured-icon" [ngClass]="['cb-type-' + type(), 'cb-size-' + size(), 'cb-color-' + color()]"
  [class.cb-disabled]="disabled()">
  <cb-icon [name]="name()"></cb-icon>
</div>